// assets/pigreco.js
document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-pigreco-variant-mf]');
    const bannerAvv = document.querySelectorAll('.availability-banner');

    if (!container && bannerAvv.length == 0) return;

    if (container) {
        const {sectionId, blockId, productUrl} = container.dataset;

        const esc = (window.CSS && CSS.escape) ? CSS.escape : (s) => String(s).replace(/[^a-zA-Z0-9_\-]/g, '\\$&');

        const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
        const getVariantId = () => document.querySelector('input[name="id"]')?.value || null;

        const fetchAndSwapBlock = async (variantId) => {
            if (!variantId) return;
            const url = `${productUrl}?section_id=${encodeURIComponent(sectionId)}&variant=${encodeURIComponent(variantId)}`;

            try {
                const res = await fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
                if (!res.ok) return;

                const html = await res.text();
                const tmp = document.createElement('div');
                tmp.innerHTML = html;

                let fresh = tmp.querySelector(`#variant-metafields-${esc(blockId)}`);
                if (!fresh) fresh = tmp.querySelector('[data-pigreco-variant-mf]');
                if (fresh) container.innerHTML = fresh.innerHTML;

                if (window.Shopify && Shopify.designMode) {
                    console.log('[pigreco] reload OK', {variantId, sectionId, blockId});
                }

                // dopo aver ricaricato la tabella, aggiorna anche gli stock
                updateStocks();

            } catch (e) {
                if (window.Shopify && Shopify.designMode) console.warn('[pigreco] reload KO', e);
            }
        };

        const onChange = () => fetchAndSwapBlock(getVariantId());

        if (productForm) {
            productForm.addEventListener('change', onChange);
            productForm.addEventListener('input', (e) => {
                const n = e.target?.name || '';
                if (n === 'id' || n.startsWith('options')) onChange();
            });
        }

        document.addEventListener('variant:change', (e) => {
            const v = e?.detail?.variant || e?.detail?.variantId;
            fetchAndSwapBlock(typeof v === 'object' ? v.id : v);
        });

        fetchAndSwapBlock(getVariantId());

        // ---- Gestione stocks ----
        const updateStocks = async () => {
            const nodes = document.querySelectorAll('.variant-metafields-table .light[data-sku]');
            const banner = document.getElementById('availability-banner');

            const qtyNode = document.querySelector('.quantity-cart');

            const qtyToCart = Number(
            qtyNode?.querySelector('input')?.value ||
            qtyNode?.textContent?.trim() ||
            1
            );

            if (!nodes.length || !banner) return;

            let showBanner = false;
            let overStock = false;
            // Legge le traduzioni dal DOM (in base alla lingua attiva del tema)
            const msgs = {
                inStock: banner.dataset.msgInStock || '',
                toBuild: banner.dataset.msgToBuild || '',
                outOfStock: banner.dataset.msgOutOfStock || '',
                overStock: banner.dataset.msgOverStock || ''
            };

            for (const node of nodes) {
                const sku = node.dataset.sku;
                if (!sku) continue;

                try {
                    const res = await fetch(`/apps/bridge/stock/status/${encodeURIComponent(sku)}`, {
                        method: 'GET',
                        headers: {'Accept': 'application/json'}
                    });

                    if (!res.ok) continue;
                    const json = await res.json();
                    const status = json?.status || '';

                    if(qtyToCart >= json?.qty){
                        banner.classList.add('overStock');
                        banner.textContent = msgs.overStock;
                        showBanner = true;
                        overStock = false;
                    }

                    // pulizia + applica classe status
                    node.classList.remove('inStock', 'toBuild', 'outOfStock');

                    // applica nuova classe in base allo status
                    if (status === 'inStock') {
                        node.classList.add('inStock');
                    } else if (status === 'toBuild') {
                        node.classList.add('toBuild');
                        if(!overStock){
                            banner.classList.add('toBuild');
                            banner.textContent = msgs.toBuild;
                            showBanner = true;
                        }
                    } else if (status === 'outOfStock') {
                        node.classList.add('outOfStock');

                        if(!overStock){
                            banner.classList.add('outOfStock');
                            banner.textContent = msgs.outOfStock;
                            showBanner = true;
                        }
                    }

                    node.dataset.status = status;

                } catch (e) {
                    console.warn('[pigreco] stock KO', sku, e);
                }
            }

            // gestisci il banner
            if (showBanner) {
                banner.hidden = false;
            } else {
                banner.textContent = '';
                banner.hidden = true;
            }
        };

        window.subscribe(PUB_SUB_EVENTS.cartUpdate, async function reloadBanner(e) {
            setTimeout(() => {
                updateStocks();
            },800)
    
        });
    }

    if (bannerAvv.length > 0) {
        const PROXY_BASE = '/apps/bridge/stock/status';

        async function fetchStatus({sku, variantId, quantity}) {
            const url = `${PROXY_BASE}/${encodeURIComponent(sku)}`;

            const res = await fetch(url, {credentials: 'same-origin'});
            if (!res.ok) throw new Error('Proxy error');
            return res.json(); // atteso { status: 'inStock'|'toBuild'|'outOfStock' , availableQty?: number }
        }

        function setBanner(el, data) {
            // reset classi stato
            el.classList.remove('inStock', 'toBuild', 'outOfStock');

            let msg = '';

            // Ottieni la quantità selezionata dal carrello
            // Qui assumo che l'elemento del banner sia nello stesso container del quantity input
            const input = el.closest('tr')?.querySelector('td.cart-item__quantity .quantity__input');
            const selectedQty = input ? parseInt(input.value, 10) || 0 : 0;

            const availableQty = parseInt(data.qty, 10) || 0;

            // Se la quantità richiesta supera quella disponibile → forzo lo stato a 'toBuild'
            let status = data.status;
            if (selectedQty > availableQty && availableQty > 0) {
                el.classList.add('overStock');
                msg = el.dataset.msgOverStock
            } 
            /*else {

                switch (status) {
                    case 'inStock':
                        el.classList.add('inStock');
                        msg = el.dataset.msgInStock;
                        break;
                    case 'toBuild':
                        el.classList.add('toBuild');
                        msg = el.dataset.msgToBuild;
                        break;
                    default:
                        el.classList.add('outOfStock');
                        msg = el.dataset.msgOutOfStock;
                }
            }*/

            el.textContent = msg || '';
            el.hidden = !msg;
        }

        async function initBanners(root = document) {
            const banners = Array.from(root.querySelectorAll('.availability-banner'));
            if (!banners.length) return;

            for (const el of banners) {
                const sku = el.dataset.sku || '';
                const variantId = el.dataset.variantId || '';
                const quantity = Number(el.dataset.quantity || '1');

                if(!sku) return;

                try {
                    const data = await fetchStatus({sku, variantId, quantity});
                    setBanner(el, data);
                } catch (e) {
                    // silenzioso: non bloccare il carrello se il proxy è giù
                    el.hidden = true;
                }
            }
        }

        initBanners();

        // rilegare su aggiornamenti del carrello (drawer/ajax)
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, async function reloadBanner(e) {
                const root = e.detail?.cartDrawer || document;
                await initBanners();
            });
    }
});